// GSAP border-trace animation for .invite-feature-card
// Draws a rounded-rect border counterclockwise from the top-left corner:
//   top-left → bottom-left → bottom-right → top-right → back to top-left
// Reverses on mouse-leave.

window.initFeatureCardBorder = function initFeatureCardBorder() {
    const gsap = window.gsap;
    if (!gsap) return;

    const container = document.getElementById('invitePreviewFeatures');
    if (!container) return;

    _bindCards(container);

    // Re-bind whenever the grid is re-rendered (after updateInvitePreview)
    if (!container._borderObserver) {
        const mo = new MutationObserver(() => _bindCards(container));
        mo.observe(container, { childList: true });
        container._borderObserver = mo;
    }
};

function _bindCards(container) {
    container.querySelectorAll('.invite-feature-card').forEach(card => {
        if (card._borderBound) return;
        card._borderBound = true;

        // ------------------------------------------------------------------
        // Inject SVG border overlay once per card
        // ------------------------------------------------------------------
        let svg = card.querySelector('.feat-border-svg');
        if (!svg) {
            svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.classList.add('feat-border-svg');
            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.classList.add('feat-border-path');
            svg.appendChild(path);
            card.appendChild(svg);
        }

        const path = svg.querySelector('.feat-border-path');
        let tween = null;

        function getPerimeter(el) {
            const r   = el.getBoundingClientRect();
            const w   = r.width;
            const h   = r.height;
            const rad = 16; // matches inner arc for border-radius: 18px

            // CCW rounded-rect path starting at top-left arc end going DOWN
            //   M  top-left (after arc),  arc TL,  line to bottom-left arc start,
            //   arc BL, line to BR arc start, arc BR, line to TR arc start,
            //   arc TR, line to TL arc start (top), arc TL close
            const d = [
                `M ${rad},0`,
                // top edge → top-right arc
                `L ${w - rad},0`,
                `Q ${w},0 ${w},${rad}`,
                // right edge → bottom-right arc
                `L ${w},${h - rad}`,
                `Q ${w},${h} ${w - rad},${h}`,
                // bottom edge → bottom-left arc
                `L ${rad},${h}`,
                `Q 0,${h} 0,${h - rad}`,
                // left edge → top-left arc
                `L 0,${rad}`,
                `Q 0,0 ${rad},0`,
                'Z',
            ].join(' ');

            return { d, perimeter: 2 * (w + h) };
        }

        function setup() {
            const { d, perimeter } = getPerimeter(card);
            path.setAttribute('d', d);
            path.style.strokeDasharray  = perimeter;
            path.style.strokeDashoffset = perimeter; // fully hidden initially

            // Move dashoffset origin so drawing starts from top-left going
            // counterclockwise (left side down, bottom right, right up, top left).
            // SVG rects go CW by default, so we offset by -perimeter to reverse.
            // Instead we use a negative dashoffset equal to perimeter to draw CCW:
            path.style.strokeDashoffset = perimeter;
        }

        setup();

        // Hover animations using GSAP
        card.addEventListener('mouseenter', () => {
            if (tween) tween.kill();
            setup();
            const { perimeter } = getPerimeter(card);
            
            tween = gsap.to(path, {
                strokeDashoffset: 0,
                duration: 0.55,
                ease: 'power2.out',
            });
        });

        card.addEventListener('mouseleave', () => {
            if (tween) tween.kill();
            const { perimeter } = getPerimeter(card);
            const current = parseFloat(path.style.strokeDashoffset) || 0;
            tween = gsap.to(path, {
                strokeDashoffset: perimeter,
                duration: 0.45,
                ease: 'power2.in',
            });
        });
    });
}
